import React from 'react';

const NotFound = () => {
  return <h1>This page is under construction</h1>;
};

export default NotFound;
